import { callAPI } from "../../../../api/client";

export interface ExportRequest {
  duration: number;
  unit: "hours" | "days";
}

export const exportConversations = async (params: ExportRequest): Promise<string> => {
  // NOTE: hardcoding the endpoint for now to avoid creating new env values
  const response = await callAPI("/conversations/export/csv", params, "POST");

  if (!response.ok) {
    throw new Error(`API returned ${response.status}: ${response.statusText}`);
  }

  const csvData = await response.text();
  return csvData;
};
